import namespace from "@rdfjs/namespace";

export {
  dcat,
  dcterms,
  geo,
  qudt,
  rdf,
  rdfs,
  schema,
  sh,
  skos,
  time,
  vcard,
  xsd,
} from "@tpluscode/rdf-ns-builders";

export const adminVocabulary = namespace("https://ld.admin.ch/vocabulary/");
export const cube = namespace("https://cube.link/");
export const cubeView = namespace("https://cube.link/view/");
export const cubeMeta = namespace("https://cube.link/meta/");
export const visualizeAdmin = namespace("https://visualize.admin.ch/");
